import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useAppStore } from '@/store';
import { Bot } from 'lucide-react';

const CohereSettings = () => {
  const { cohereKey, setCohereKey } = useAppStore();

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-2">
          <Bot size={20} />
          <CardTitle>Cohere</CardTitle>
        </div>
        <CardDescription>
          Enter your Cohere API key. This will be stored locally on your device.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          <Label htmlFor="cohere-key">API Key</Label>
          <Input
            id="cohere-key"
            type="password"
            value={cohereKey || ''}
            onChange={(e) => setCohereKey(e.target.value)}
            placeholder="Enter your Cohere API key"
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default CohereSettings;